import { render, staticRenderFns } from "./Contador.vue?vue&type=template&id=5d381aec&"
import script from "./Contador.vue?vue&type=script&lang=js&"
export * from "./Contador.vue?vue&type=script&lang=js&"
import style0 from "./Contador.vue?vue&type=style&index=0&id=5d381aec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports